import { createUseStyles } from "react-jss";
import { ITheme } from "../../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "fixed",
    width: "100vw",
    height: "100vh",
    zIndex: theme.zIndex.dialog + 2,
    top: 0,
    left: 0,
    justifyContent: "center",
    animation:
      "$fadeOut ease-out 0.3s 5.5s forwards, $scaleDown ease-out 0.5s 5.5s forwards",
    pointerEvents: "none",
    color: theme.colors.text1,
  },
  rewardBoxContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    "&.streak": {
      animation: "$fadeOut ease-out 0.5s 2.5s forwards",
    },
    "&.rewardBox": {
      position: "absolute",
    },
  },
  streak: {
    fontSize: 80,
    color: theme.colors.text1,
    fontWeight: theme.fontWeight.bold,
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    "&.preStreak": {
      color: theme.colors.text2,
      fontSize: 60,
      top: theme.spacing.space12,
      animation: "$fadeOut ease-out 0.5s 1s forwards",
      position: "absolute",
    },
    "&.currentStreak": {
      opacity: 0,
      animation: "$fadeIn ease-out 0.5s 1.2s forwards",
    },
  },
  streakNumber: {
    scale: 0.5,
    animation: "$scaleUp ease-out 0.3s 1.2s  forwards",
  },
  streakContainer: {
    position: "relative",
  },
  fireIcon: {
    width: 60,
    height: 60,
    opacity: 1,
    "&.current": {
      animation: "$fireStreak .35s 1.8s linear infinite",
    },
  },
  streakStar: {
    position: "absolute",
    opacity: 0,
    top: 0,
    animation: "$fireStreakStar .35s 1.8s linear infinite",
  },
  rewardBox: {
    position: "absolute",
    opacity: 0,
    animation:
      "$fadeIn ease-out 0.5s 2.8s forwards, $shake ease-out 0.2s 3.0s , $fadeOut ease-out 0.5s 3.5s forwards",
  },
  rewardBoxOpen: {
    position: "absolute",
    opacity: 0,
    animation:
      "$fadeIn ease-out 0.5s 3.5s forwards, $fadeOut ease-out 0.5s 4.5s forwards",
  },
  gemNumber: {
    opacity: 0,
    fontSize: "60px !important",
    position: "absolute",
    top: "20%",
    animation:
      "$fadeIn ease-out 0.5s 3.5s forwards, $scaleUp ease-out 0.5s 3.5s forwards, $gemFlyUp ease-out 0.5s 3.5s forwards, $gemFlyDown ease-out 0.8s 4.5s forwards",
  },
  shineEffect: {
    position: "absolute",
    top: "30%",
    width: "100vw",
    maxWidth: "100vh",
    opacity: 0,
    animation: "$fadeIn ease-out 0.5s 4.5s forwards",
  },
  "@keyframes fadeOut": {
    "0%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@keyframes gemFlyDown": {
    "0%": {
      top: "20%",
    },
    "100%": {
      top: "50%",
    },
  },
  "@keyframes gemFlyUp": {
    "0%": {
      top: "50%",
    },
    "100%": {
      top: "20%",
    },
  },
  "@keyframes scaleUp": {
    "0%": {
      scale: 0.5,
    },
    "100%": {
      scale: 1,
    },
  },
  "@keyframes scaleDown": {
    "0%": {
      scale: 1,
    },
    "100%": {
      scale: 0.1,
    },
  },
  "@keyframes shake": {
    "0%": {
      transform: "rotate(0)",
    },
    "25%": {
      transform: "rotate(-60deg)",
    },
    "50%": {
      transform: "rotate(0)",
    },
    "75%": {
      transform: "rotate(60deg)",
    },
    "100%": {
      transform: "rotate(0)",
    },
  },
  "@keyframes fireStreak": {
    // .35s linear infinite
    "0%": {
      transform: "scaleX(1.2)",
    },
    "50%": {
      transform: "scaleY(1.2)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
  "@keyframes fireStreakStar": {
    // .35s linear infinite
    "0%": {
      transform: "translateY(40px)",
      opacity: 1,
    },
    "70%": {
      opacity: 1,
    },
    "71%": {
      opacity: 0,
    },
    "100%": {
      opacity: 0,
    },
  },
}));
